<template>
    <div class="lib-dropdown">
        <lib-select
            :options="options"
            :value="value"
            :right-aligned="true"
            @input="$emit('input', $event)"
        >
            <template v-slot:selected="props">
                <div class="explanation">{{ explanation ? explanation : "" }}</div>
                <span class="description">{{ props.option.description }}</span>
            </template>
            <template v-slot:descriptions="props">
                <span v-if="props.option.other" class="other">{{ props.option.other }}</span>
                <span class="description">{{ props.option.description }}</span>
            </template>
        </lib-select>
    </div>
</template>

<script>
import {mixin as clickaway} from './plugins/vue-clickaway';

export default {
    name: 'LibDropdown',
    mixins: [clickaway],
    props: ['options', 'value', 'explanation'],
    data() {
        return {
            open: false,
        };
    },
    methods: {
        select(index) {
            this.open = false;
            this.$emit('input', index);
        },
        clickaway() {
            this.open = false;
        },
    },
    computed: {
        display() {
            return this.options[this.value].description;
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../styles/prelude/index";

.lib-dropdown {
    position: relative;
    max-width: 354px;

    .explanation {
        color: $darkgray;
        font-weight: normal;
        position: absolute;
        left: 16px;
    }

    .description {
        font-weight: bold;
    }

    .other {
        color: $navy;
        opacity: 0.2;
        text-transform: uppercase;
        position: absolute;
        right: 180px;
        font-size: 8px;
        line-height: 16px;
        vertical-align: baseline;
        font-weight: bold;
        letter-spacing: 1.2px;
    }
}
</style>